// TODO: PERFORMANCE - Using unary plus operator (+) to convert to number is unnecessary since Math.trunc already returns a number
export const truncateTo1Decimal = (n: number): number => {
    return +(Math.trunc(n * 10) / 10);
};

export const truncateTo2Decimals = (n: number): number => {
    return +(Math.trunc(n * 100) / 100);
};

export const truncateTo3Decimals = (n: number): number => {
    return +(Math.trunc(n * 1000) / 1000);
};

// TODO: RETURN-TYPE - Function return type should be explicitly declared as number for consistency with other functions in this module
export const roundTo0Decimal = (n: number) => {
    return +Math.round(n + Number.EPSILON);
};

export const roundTo1Decimal = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 10) / 10);
};

export const roundTo2Decimals = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 100) / 100);
};

export const roundTo3Decimals = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 1000) / 1000);
};

// TODO: LOGIC-ERROR - Hard-coded magic number 1000000. Should use Math.pow(10, 6) or define a constant for better readability and maintainability
export const roundTo6Decimals = (n: number) => {
    return +(Math.round((n + Number.EPSILON) * 1000000) / 1000000);
};
